import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { GanttEditor, GanttEditorX } from './GanttEditor';
import { useParams } from 'react-router-dom';
import { useCrudItem } from '../../toolympus/api/useSimpleCrud';
import { GanttApiPath, GanttRecord } from './useGanttsList';
import { EMPTY_GANTT_STATE, useGanttState } from './hooks/useGanttState';
import { useSnackbar } from 'notistack';

interface Props {
  
}

export const GanttPageLoaded = (props: Props) => {
  const { id } = useParams<{ id: string }>();
  const dataIn = useCrudItem<GanttRecord>(`${GanttApiPath}/${id}`, {
    defaultValue: { title: "...", data: EMPTY_GANTT_STATE } as any,
  });

  const data = useGanttState();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    data.setData(dataIn.data.data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIn.data])

  return (
    <Wrapper>
      <GanttEditor
        data={data}
        save={async () => {
          await dataIn.save({ data: data.data })
          enqueueSnackbar("Saved!", { variant: "success" });
        }}
        />

      <style>
        {`html, body { overscroll-behavior-x: none; }`}
      </style>
    </Wrapper>
  );
}

export const GanttPage = (props: Props) => {
  return (
    <Wrapper>
      <GanttEditorX
        
        />

      <style>
        {`html, body { overscroll-behavior-x: none; }`}
      </style>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 1rem 1rem 0;
  height: 100vh;
  overscroll-behavior-x: none;

  @media print {
    & .toolbar {
      display: none !important;
    }

    & .gantt-editor {
    }
  }
`;